interface Number {
    formatMoney(thousandSeparator?: string): string;
    parseDecimalToMoney(thousandSeparator: string): string;
}

Number.prototype.formatMoney = function (thousandSeparator?: string): string {
    try {
        const intVal = this;
        if (intVal == 0) return "0";
        if (thousandSeparator == ',')
            return intVal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/.00$/, "");
        return intVal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&.').replace(/.00$/, "");
    } catch (error) {
        return "0";
    }
}

Number.prototype.parseDecimalToMoney = function (thousandSeparator: string): string {
    let number = this;
    let strArr = number.toString().split('.');
    return strArr[0].formatMoney(thousandSeparator) + (thousandSeparator == '.' ? ',' : '.') + strArr[1];
}